<!-- <div [ngClass]="{'has-error':form.controls['date'].errors && (form.controls['date'].dirty || form.controls['date'].touched)}"> -->
<!-- <div class="valid"> -->
<form [formGroup]="form" *ngIf="form">
  <label *ngIf="label && label.length > 0" class="mb-3">{{ label }} </label>
  <span *ngIf="showIsRequiredSpan" style="color: red">*</span>

  <div class="calendar input-daterange input-group mb-5">
    <div class="col-12 p-0">
      <div class="row m-0">
        <div class="input-with-icon col p-0">
          <input
            class="form-control"
            [ngModelOptions]="{ standalone: true }"
            (change)="isFormValid()"
            formControlName="date"
            style="background-color: #ffffff"
            (dateSelect)="selectDate()"
            (click)="dp.toggle()"
            [footerTemplate]="footerTemplate"
            [placeholder]="placeHolder"
            name="d"
            ngbDatepicker
            [disabled]="isDisabled"
            [minDate]="minDate"
            [maxDate]="maxDate"
            #dp="ngbDatepicker"
            type="text"
          />

          <span class="icon-calendar"></span>
          <div
            class="text-danger"
            *ngIf="
              form.controls['date'].hasError('required') &&
              form.controls['date'].dirty
            "
          ></div>
          <ng-template ngbDatepickerContent>
            <div *ngFor="let month of dp.state.months">
              <div class="text-primary p-1 fw-bold">
                {{ i18n.getMonthShortName(month.month) }} {{ month.year }}
              </div>
              <ngb-datepicker-month
                class="border rounded"
                [month]="month"
              ></ngb-datepicker-month>
            </div>
          </ng-template>

          <ng-template #footerTemplate>
            <div class="calendar-footer d-flex justify-content-end">
              <button
                class="btn btn-primary m-2 float-start"
                (click)="selectToday()"
              >
                تطبيق
              </button>
              <button
                class="btn btn-outline-secondary m-2 float-end"
                (click)="dp.close(); resetDate();"
              >
                إلغاء
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- <ng-container *ngIf="displayFooter"> -->
<!-- </ng-container> -->
<!-- </div> -->
<!-- </div> -->
